import SVG from 'react-inlinesvg';

import imageSvg from 'assets/icons/image.svg';
import scrollingSvg from 'assets/icons/scrolling.svg';
import videoSvg from 'assets/icons/video.svg';
import Tooltip, { TooltipSize } from 'lib/Tooltip';

interface AssetTypeProps {
  value: string;
}

const AssetType = ({ value }: AssetTypeProps): React.ReactElement => {
  switch (value) {
    case 'STATIC':
      return (
        <Tooltip tooltip="Static" size={TooltipSize.FIT}>
          <SVG src={imageSvg} className="fill-current text-neutral-600" />
        </Tooltip>
      );
    case 'SCROLLING':
      return (
        <Tooltip tooltip="Scrolling" size={TooltipSize.FIT}>
          <SVG src={scrollingSvg} className="fill-current text-neutral-600" />
        </Tooltip>
      );
    case 'DIGITAL':
      return (
        <Tooltip tooltip="Digital" size={TooltipSize.FIT}>
          <SVG src={videoSvg} className="fill-current text-neutral-600" />
        </Tooltip>
      );
    default:
      return <span>{value}</span>;
  }
};

export default AssetType;
